import { useBudget } from "./useBudget";

export const useBudgetRestricted = () => {
  const { data } = useBudget({ staleTime: Infinity });

  const isRestricted =
    data != null &&
    data.config != null &&
    data.spend.total.remaining !== null &&
    data.spend.total.remaining <= 0;

  return { isRestricted };
};
